/*
 * 时间戳 转 时间
 * yyyy-MM-dd HH:mm:ss
 */
let formatDate = (value, type) => {
  if (value) {
    var date = new Date(parseInt(value))
    if (/(y+)/.test(type)) {
      type = type.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    var padLeftZero = function (str) {
      return ('00' + str).substr(str.length)
    }
    for (let k in o) {
      if (new RegExp(`(${k})`).test(type)) {
        let str = o[k] + ''
        type = type.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
      }
    }
    return type
  }
}
export { formatDate }

/*
* 截取
*/
let limitTo = (value, length) => {
  if (value) {
    length = parseInt(length)
    value = (length > 0) ? value.substr(0, length) : value.substr(value.length + length, -length)
    return value
  }
}
export { limitTo }

/*
* 截取
*/
let number = (value, length) => {
  if (value) {
    return value.toFixed(length)
  }
}
export { number }

/*
* 文件大小
*/
let fileSize = (value, empty) => {
  value = parseInt(value)
  let kb = value / 1024
  let mb = value / 1024 / 1024
  let gb = value / 1024 / 1024 / 1024
  var math = function (num) {
    return (Math.ceil(num * 10)) / 10
  }
  if (!gb) {
    return empty
  } else if (gb > 1024) {
    return (gb / 1024) + 'T'
  } else if (mb > 1024) {
    return math(mb / 1024) + 'G'
  } else if (kb > 1024) {
    return math(kb / 1024) + 'M'
  } else if (value > 1024) {
    return math(kb) + 'kb'
  } else {
    return '1kb'
  }
}
export { fileSize }

/*
* 省市区代码转文本
*/
let areaTo = (value) => {
  let text = ''
  let list = []
  if (value) {
    value.split(',').map((item) => {
      list.push(item.split(':')[1])
    })
    list.map((item) => {
      text += item
    })
  }
  return text
}
export { areaTo }



// WEBPACK FOOTER //
// ./src/filter/filter.js